import {Address} from '../address/address.model';
import {CrudModel} from '@ngx-ivengi/crud';

export class Owner extends CrudModel {

  public name: string;
  public address: Address = new Address;
  public contactCount: number;

  public setName(name: string): Owner {
    if(typeof name === 'string') {
      this.name = name;
    }
    return this;
  }

  public setContactCount(contactCount: number): Owner {
    if(typeof contactCount === 'number') {
      this.contactCount = contactCount;
    }
    return this;
  }

  public fromResponse(response): void {
    this
      .setId(response.id)
      .setName(response.name)
      .setContactCount(response.contactCount);

    if(response.address) {
      this.address
        .setAddress(response.address.address)
        .setZip(response.address.zip)
        .setCity(response.address.city)
        .setCountry(response.address.country);
    }
  }


}



// WEBPACK FOOTER //
// /var/jenkins_home/workspace/brands-compart-portal-frontend/checkout/src/app/components/owner/owner.model.ts